<template>
  <Dropdown ref="dropdown" :disabled="disabled">
    <DropdownTrigger slot-scope="{ toggle }" :handle-click="toggle"
                     class="form-select form-control border border-50 rounded-lg bg-white hover:bg-40 active:bg-50">
      {{ $t('Export') }}
    </DropdownTrigger>

    <DropdownMenu slot="menu" direction="rtl" style="width: 150px;">
      <ul>
        <li v-for="(format, index) in formats" :key="index" class="hover:bg-40 active:bg-50">
          <button class="h-9 px-3" @click="handleExportClick(format)">{{ format.label }}</button>
        </li>
      </ul>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
  import Dropdown from '@/_legacy/components/Dropdown.vue';
  import DropdownMenu from '@/_legacy/components/DropdownMenu.vue';
  import DropdownTrigger from '@/_legacy/components/DropdownTrigger.vue';

  export default {

    components: {
      Dropdown,
      DropdownMenu,
      DropdownTrigger,
    },

    props: {
      formats: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      handleExportClick(format) {
        this.$emit('export', format.value);
        this.$refs.dropdown.close();
      },
    },
  };
</script>
